import CourseBanner from './CourseBanner'

export default CourseBanner
